import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { getImpactMediaPartnersPath, getImpactAuthHeader } from "./config";

export const getAllCampaigns = async () => {
    const url = `${getImpactMediaPartnersPath()}/Campaigns`;
    const { data } = await axios.get(url, {
        headers: {
            Authorization: getImpactAuthHeader(),
            Accept: "application/json",
        },
    });
    return data;
};

export default function useGetCampaigns() {
    return useQuery({
        queryKey: ["impact-all-campaigns"],
        queryFn: getAllCampaigns,
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}
